export default function LoadingSpinner({ label, className = '', size = 'lg', inline = false }) {
  const sizeClasses = size === 'sm' ? 'h-5 w-5' : size === 'md' ? 'h-8 w-8' : 'h-12 w-12'
  const wrapper = inline ? 'inline-flex' : 'flex'
  const wrapperClass = className || (inline ? '' : 'h-64')
  return (
    <div className={`${wrapper} items-center justify-center ${label ? 'flex-col gap-4' : ''} ${wrapperClass}`}>
      <div className={`animate-spin ${sizeClasses} border-b-2 border-cinema-gold`} />
      {label && <p className="cinema-label">{label}</p>}
    </div>
  )
}
